import { z } from 'zod';

/**
 * GET questions/nature_of_transactions
 */
export const natureOfTransactionsValues = [
  'long_term_investment',
  'other',
  'short_term_investment',
] as const;

export const ZodNatureOfTransactions = z.enum(natureOfTransactionsValues);

export type NatureOfTransactionsType = z.infer<typeof ZodNatureOfTransactions>;
